import { useEffect } from 'react';

import BpkGraphicPromo, {
  TEXT_ALIGN,
} from '@skyscanner-internal/backpack-web/bpk-component-graphic-promotion';
import { BpkBox } from '@skyscanner-internal/backpack-web/bpk-component-layout';
import { useEverywhereSearchNavigation } from '@web-platform/shared-banana-redux/src/helpers/navigationHandlers/useEverywhereSearchNavigation';
import { ANALYTICS_EVENTS } from '@web-platform/shared-universal-constants-tracking';
import { homepageFallbackAdLoaded } from '@web-platform/shared-universal-redux/src/actions/render';
import { trackInteractionEvent } from '@web-platform/shared-universal-tracking/src/trackInteractionEvent/trackInteractionEvent';
import { translate } from '@web-platform/shared-universal-translations';
import { useDispatch } from 'react-redux';

import STYLES from './GraphicPromoFallbackCard.module.scss';

const onCardClick = (handleEverywhereSearchNavigation: () => void) => {
  trackInteractionEvent({
    name: ANALYTICS_EVENTS.INTERACTION.HOMEPAGE_FALLBACK_AD_TAPPED.NAME,
    bools: {
      ENABLE_GRAPHIC_PROMO: true,
    },
  });
  handleEverywhereSearchNavigation();
};

export type OwnProps = {
  fallbackReason: string;
};

export type Props = OwnProps;

export const GraphicPromoFallbackCard = ({ fallbackReason }: Props) => {
  const dispatch = useDispatch();

  const { handleEverywhereSearchNavigation } = useEverywhereSearchNavigation({
    tracking: { trackInteractionEvent },
  });

  useEffect(() => {
    trackInteractionEvent({
      name: ANALYTICS_EVENTS.INTERACTION.HOMEPAGE_FALLBACK_AD_LOADED.NAME,
      strings: {
        reason: fallbackReason,
      },
    });

    dispatch(homepageFallbackAdLoaded());
  }, [dispatch, fallbackReason]);

  return (
    <BpkBox data-testid="GraphicPromoFallbackCard">
      <BpkGraphicPromo
        contentId="graphic-promo__fallback"
        tagline={translate('label_graphic_promo_default_subheading')}
        headline={translate('label_graphic_promo_default_heading')}
        buttonText={translate('label_graphic_promo_default_cta')}
        invertVertically
        textAlign={TEXT_ALIGN.start}
        className={STYLES.graphicPromo}
        style={{
          '--background-image-mobile':
            "url('https://content.skyscnr.com/m/566fac3b69e0a95c/Large-eyeem-26694340-113506648.jpg')",
          '--background-image-tablet':
            "url('https://content.skyscnr.com/m/6966920846d32ba/original/eyeem-26694340-113506648_TABLET.png')",
          '--background-image-desktop':
            "url('https://content.skyscnr.com/m/3c616c61b2b5adf3/original/eyeem-26694340-113506648_EDIT.jpg')",
        }}
        onClick={() => onCardClick(handleEverywhereSearchNavigation)}
      />
    </BpkBox>
  );
};
